module.exports = __webpack_public_path__ + "img/default-header-icon.5abe9464.png";